import type { WhatsAppServer } from '../api/whatsapp-servers.service';

export function getServerStatusColor(server: WhatsAppServer) {
  return server.isActive ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800';
}

export function getServerStatusText(server: WhatsAppServer) {
  return server.isActive ? 'Ativo' : 'Inativo';
}
